"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumberK = formatNumberK;
/**
 * @reference https://stackoverflow.com/a/9461657
 *
 * @param num
 * @returns {*}
 */
function formatNumberK(num) {
  return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k' : Math.sign(num) * Math.abs(num);
}